<template>
  <ul class="word_list flex">
    <li @click="routePush(item.id)" v-show="$route.meta != item.title" v-for="(item, index) in list" :key="index">
      <img :src="item.imgUrl" alt="">
      <p>{{ item.title }}</p>
    </li>
  </ul>
</template>

<script>
export default {
  name: '',
  created() { },
  mounted() { },
  data() {
    return {
      list: [
        {
          id: 0,
          imgUrl: require('../assets/wordOp/1.png'),
          title: '个人简介',
          free: require('../assets/wordOp/free.png')
        },
        {
          id: 1,
          imgUrl: require('../assets/wordOp/2.png'),
          title: '广告语',
          free: require('../assets/wordOp/free.png')
        },
        {
          id: 2,
          imgUrl: require('../assets/wordOp/3.png'),
          title: '文稿润色',
        },
        {
          id: 3,
          imgUrl: require('../assets/wordOp/4.png'),
          title: '错别字修改',
        },
        {
          id: 4,
          imgUrl: require('../assets/wordOp/5.png'),
          title: '记叙文',
        },
        {
          id: 5,
          imgUrl: require('../assets/wordOp/6.png'),
          title: '产品简介',
          free: require('../assets/wordOp/free.png')
        },
        {
          id: 6,
          imgUrl: require('../assets/wordOp/7.png'),
          title: '短视频脚本',
        },
        {
          id: 7,
          imgUrl: require('../assets/wordOp/8.png'),
          title: '议论文',
        },
        {
          id: 8,
          imgUrl: require('../assets/wordOp/9.png'),
          title: '祝福语',
          free: require('../assets/wordOp/free.png')
        },
        {
          id: 9,
          imgUrl: require('../assets/wordOp/10.png'),
          title: '文稿改写',
        },
        {
          id: 10,
          imgUrl: require('../assets/wordOp/11.png'),
          title: '企业简介',
          free: require('../assets/wordOp/free.png')
        },
        {
          id: 11,
          imgUrl: require('../assets/wordOp/12.png'),
          title: '纪录片脚本',
        },
        {
          id: 12,
          imgUrl: require('../assets/wordOp/13.png'),
          title: '标题提炼',
        },
        {
          id: 13,
          imgUrl: require('../assets/wordOp/14.png'),
          title: 'AI绘画',
        },
      ],
      fullscreenLoading: false
    }
  },
  methods: {
    routePush(id) {
      this.fullscreenLoading = true;
      setTimeout(() => {
        this.fullscreenLoading = false;
        switch (id) {
          case 10:
            this.$router.push({
              path: '/EnterpriseProfile',
              query: {

              }
            })
            break;
          case 0:
            this.$router.push({
              path: '/IndividualResume',
              query: {

              }
            })
            break;
          case 5:
            this.$router.push({
              path: '/productResume',
              query: {

              }
            })
            break;
          case 7:
            this.$router.push({
              path: '/esay',
              query: {

              }
            })
            break;
          case 4:
            this.$router.push({
              path: '/narration',
              query: {

              }
            })
            break;
          case 1:
            this.$router.push({
              path: '/slogan',
              query: {

              }
            })
            break;
          case 8:
            this.$router.push({
              path: '/greeting',
              query: {

              }
            })
            break;
          case 3:
            this.$router.push({
              path: '/wrongly',
              query: {

              }
            })
            break;
          case 12:
            this.$router.push({
              path: '/titleExtraction',
              query: {

              }
            })
            break;
          case 2:
            this.$router.push({
              path: '/manuscriptPolishing',
              query: {

              }
            })
            break;
          case 9:
            this.$router.push({
              path: '/manuscriptRewriting',
              query: {

              }
            })
            break;
          case 6:
            this.$router.push({
              path: '/shortVideo',
              query: {

              }
            })
            break;
          case 13:
            this.$router.push({
              path: '/paint',
              query: {

              }
            })
          default:
            break;
        }
      }, 1000);
      // console.log(item);

    }
  },
}
</script>

<style lang=scss scoped>
.word_list {
  width: 30%;
  margin: 5rem 0 2rem 0;
  justify-content: space-between;
  flex-wrap: wrap;

  li {
    // margin: 0 1rem 1rem 0;
    width: 10rem;
    height: 10rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    text-align: center;
    border-radius: 1.25rem;
    border: 0.25rem solid rgba(255, 255, 255, 1);
    justify-content: center;
    transition: 0.3s;
    cursor: pointer;
    margin-bottom: 1rem;

    &:hover {
      background: rgba(196, 227, 255, 1);
    }

    img {
      width: 4rem;
      display: block;
      margin: 0 auto;
    }

    p {
      font-size: 1.2rem;
      color: rgba(51, 51, 51, 1);
    }
  }
}

@media screen and (max-width: 1700px) {
  .word_list {
    width: 30%;
    margin: 5rem 0 2rem 0;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
      // margin: 0 1rem 1rem 0;
      width: 30%;
      height: 10rem;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      text-align: center;
      border-radius: 1.25rem;
      border: 0.25rem solid rgba(255, 255, 255, 1);
      justify-content: center;
      transition: 0.3s;
      cursor: pointer;
      margin-bottom: 0.5rem;
      &:hover {
        background: rgba(196, 227, 255, 1);
      }

      img {
        width: 4rem;
        display: block;
        margin: 0 auto;
      }

      p {
        font-size: 1.2rem;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}
</style>